import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgWishList({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 2h10a3 3 0 013 3 1 1 0 01-1.993.117l-.014-.234a1 1 0 00-.876-.876L16 4H6a1 1 0 00-.993.883L5 5v14a1 1 0 00.883.993L6 20h10a1 1 0 00.993-.883l.014-.234A1 1 0 0119 19a3 3 0 01-2.824 2.995L16 22H6a3 3 0 01-2.995-2.824L3 19V5a3 3 0 012.824-2.995L6 2h10H6zm8.868 5.658l.15.105.17-.102C17.872 6.134 21 7.477 21 10.51c0 1.735-1.066 3.35-2.98 4.806a15.352 15.352 0 01-2.396 1.488l-.62.3-.623-.283a14.179 14.179 0 01-2.398-1.43C10.066 13.964 9 12.322 9 10.51c0-2.98 3.448-4.458 5.868-2.85zM11 10.508c0 1.085.719 2.193 2.177 3.277.413.308.865.596 1.342.86l.362.192.096.049.475-.264c.482-.279.939-.58 1.357-.898C18.274 12.609 19 11.509 19 10.508c0-1.42-1.53-2.008-3.062-.959l-1.035.71-.961-.8C12.764 8.479 11 9.163 11 10.509z"
        fill={color}
      />
    </svg>
  )
}

export default SvgWishList
